import type { IllustrationMapping } from "@foodpilot/foods";

export const csrPillarIconKeys = [
    "almostThere",
    "actions",
    "animalWelfare",
    "arrows",
    "buildingOne",
    "buildingTwo",
    "carbonEmissions",
    "carbonNeutrality",
    "comingSoon",
    "congratulations",
    "contactSupport",
    "dataAnalysis",
    "diagnosticQuestionnaire",
    "diamond",
    "economy",
    "emptyBasket",
    "emptyFolder",
    "environment",
    "governance",
    "groupOfPeople",
    "growingPlant",
    "healthAndNutrition",
    "informations",
    "inputsChemicals",
    "keepGoing",
    "lock",
    "missingData",
    "motivation",
    "noAccess",
    "packaging",
    "productSimulation",
    "recipe",
    "rocket",
    "scoresIndicators",
    "selectAction",
    "social",
    "start",
    "suppliers",
    "targetOne",
    "targetTwo",
    "termsAndConditions",
    "territory",
    "trajectoryActions",
    "underConstruction",
    "wavingHand",
] as const satisfies ReadonlyArray<keyof IllustrationMapping>;

export type CsrPillarIconKey = (typeof csrPillarIconKeys)[number];

const legacyCsrPillarIconMapping = {
    environement: "environment",
    communities: "groupOfPeople",
    filliere: "territory",
    relationships: "groupOfPeople",
    sustainableWorld: "environment",
    laboratory: "diagnosticQuestionnaire",
    productPackaging: "packaging",
    circularProduction: "arrows",
    ingredientMix: "recipe",
    community: "groupOfPeople",
    performanceGauge: "scoresIndicators",
    focusTarget: "targetOne",
    plantGrowth: "growingPlant",
    logistics: "suppliers",
    routeMap: "territory",
    regenerativeAgriculture: "productSimulation",
    technicalSupport: "contactSupport",
    celebration: "congratulations",
} as const satisfies Readonly<Record<string, CsrPillarIconKey>>;

export const fallbackCsrPillarIconKey: CsrPillarIconKey = "groupOfPeople";
export const defaultCsrPillarIconKey = fallbackCsrPillarIconKey;

export const getCsrPillarIconKey = (icon?: string | null): CsrPillarIconKey => {
    if (csrPillarIconKeys.includes(icon as CsrPillarIconKey)) {
        return icon as CsrPillarIconKey;
    }

    return legacyCsrPillarIconMapping[icon as keyof typeof legacyCsrPillarIconMapping] ?? fallbackCsrPillarIconKey;
};
